import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';

export class helpcontactsearch {
	private $scope = $('.helpcontact');
	private $form = $('#helpcontact-form');
	private $countries:Array<any>;

	/**
	 * initial get request to populate select options
	 * actual url:
	 * https://author-ma-stage62-01.adobecqms.net/bin/services/getContactInformationCountryCityListJSON
	 * @return {any} [deferred object - list of office countries & cities]
	 */
	getContactCountriesJSON():any {
		let _self = this;
		let dataUrl = _self.$scope.attr('data-get-url');
		// every static rendering will use promise. no need to worry about async issue
		let defer = $.Deferred();
		 $.get(dataUrl)
			 .done((data: any) => {
			 	// console.log(data);
				defer.resolve(data);
				})
			 .fail((error:any) => {
				 defer.reject(error);
			 });
		return defer.promise();
	}

	/**
	 * initialize help search form
	 * @param  {any} data [description]
	 * @return {any}      [description]
	 */
	initContactSearch(data:any): void {
		let _self = this;
		let countrySel:any = _self.$form.find('#helpcontact-country-select select');
		let stateSel:any   = _self.$form.find('#helpcontact-state-select select');

		let countryTitle:any = _self.$form.find('#helpcontact-country-select .booking-form--title');
		let stateTitle:any = _self.$form.find('#helpcontact-state-select .booking-form--title');

		let currCountryObj:any = $('#mab-header .selected-country').data();
		let submitBtn          = _self.$form.find('#helpcontact-form-submit');
		let contactInfo        = $('.helpcontact__contactinfo');

		// hide contact info on load
		contactInfo.hide();

		// assign data retrieved to local variable
		_self.$countries = data;

		let countries:any = [];
		for (var key in data) {
			if (data[key].cities !== undefined) {
				// console.log(key, data[key], data[key].cities);
				let keyUpp = toTitleCase(key);
				countries.push({text: keyUpp, value: key});
			}
		}

		// init selectize on input fields
		// initialize state input first as it needs to be available when country input
		// onInitialize callback is triggered
		let stateSelectize:any = stateSel.selectize({
			onFocus: () =>  {
				stateTitle.addClass('input-filled');
				stateSel[0].selectize.$control[0].classList.add('select-filled');
			},
			onChange: (val:any) =>  {
				// console.log(val);
				stateTitle.addClass('input-filled');
				stateSel[0].selectize.$control[0].classList.add('select-filled');
			},
			onBlur: () => {
				let val = stateSel.find('option:selected').text();
				if (val !== '') {
					stateTitle.addClass('input-filled');
					stateSel[0].selectize.$control[0].classList.add('select-filled');
				} else {
					stateTitle.removeClass('input-filled');
					stateSel[0].selectize.$control[0].classList.remove('select-filled');
				}
			},
			searchField: ['text'],
			selectOnTab: true
		});

		let countrySelectize:any = countrySel.selectize({
			selectOnTab: true,
			searchField: ['text'],
			options: countries,
			onInitialize: () => {
				// console.log(countrySel[0].selectize);
				if (currCountryObj !== undefined) {
					// console.log(currCountryObj.country);
					countrySel[0].selectize.addItem((currCountryObj.country).toLowerCase(), false);
					countrySel[0].selectize.refreshItems();
				}
			},
			onFocus: () =>  {
				countryTitle.addClass('input-filled');
				countrySel[0].selectize.$control[0].classList.add('select-filled');
			},
			onChange: (country:any) =>  {
				// console.log(val);
				if (country === '') return;
				countryTitle.addClass('input-filled');
				countrySel[0].selectize.$control[0].classList.add('select-filled');

				// retrieve new cities
				let cityData:any = _self.$countries[country];
				let citiesArr:any = [];

				for (var j in cityData.cities) {
					let cityItem = cityData.cities[j];
					// console.log('country', country);
					// console.log('city #', j);
					// console.log('cityItem', cityItem);
					// console.log('cityName', cityItem['city-name']);
					citiesArr.push({text: toTitleCase(cityItem['city-name']), value: (cityItem['city-name']).toLowerCase()});
				}

				// console.log(citiesArr);

				// update city options in state dropdown
				stateSel[0].selectize.clear();
				stateSel[0].selectize.clearOptions();
				stateSel[0].selectize.addOption(citiesArr);
				stateSel[0].selectize.refreshOptions(false);
				stateSel[0].selectize.addItem(citiesArr[0].value, false);
				stateSel[0].selectize.refreshItems();
			},
			onBlur: () => {
				let val = countrySel.find('option:selected').text();
				if (val !== '') {
					countryTitle.addClass('input-filled');
					countrySel[0].selectize.$control[0].classList.add('select-filled');
				} else {
					countryTitle.removeClass('input-filled');
					countrySel[0].selectize.$control[0].classList.remove('select-filled');
				}
			},
		});

		// initialize submit handler
		_self.submitHandler(countrySel[0].selectize, stateSel[0].selectize);

		// submit currently input value (to get current country contact info)
		submitBtn.trigger('click');

		/**
		 * to convert text to title case
		 * @param {string} str [text to convert]
		 * @return {string} [converted text]
		 */
		function toTitleCase(str:string) {
			return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
		}
	}

	googleMapEmbed(): void {
		let _self = this;
		let $getGoogleLocation: any = $('#google-map--loc');
		let $getGoogleMapAddress:any = encodeURIComponent($getGoogleLocation.attr('data-googlemap'));
		$getGoogleLocation.attr('src', _self.$scope.attr('data-gmaps-url') +'?key='+ _self.$scope.attr('data-gmaps-key') +'&q='+ $getGoogleMapAddress);
	}

	/**
	 * [submitHandler description]
	 * @param  {any} countrySel [country selected value]
	 * @param  {any} citySel    [city selected value]
	 * @return {any}            [true if submit success, false if fail]
	 */
	submitHandler(countrySel:any, citySel:any): void {
		let _self = this;
		let submitBtn = _self.$form.find('#helpcontact-form-submit');
		let prevCountry:string, prevCity:string;

		submitBtn.on('click', (e:any) => {
			e.preventDefault();
			e.stopPropagation();

			let country:string = countrySel.getValue();
			let city:string = citySel.getValue();

			// console.log(country, city);

			if (country !== null && city !== null && (country !== prevCountry || city !== prevCity)) {
				let couValStr:string = country.toLowerCase().split(' ').join('-');
				let citValStr:string = city.toLowerCase().split(' ').join('-');
				prevCountry = country;
				prevCity = city;

				// console.log(couValStr, citValStr);

				// Attach a done, fail, and progress handler for the asyncEvent
				$.when(getAddresses(couValStr, citValStr)).then(
					function(data:any, status:any ) {
						// console.log(data, status);
						_self.populateAddresses(data);
					},
					function(error:any, status:any ) {
						console.error(error, status);
						// _self.populateAddresses(null); // remove for production
					},
					function( status:any ) {
						$( "body" ).append( status );
					});

				return true;
			} else {
				return false;
			}
		});

		/**
		 * get request to retrieve office contact info
		 * actual url:
		 * https://ma-dev62-01.adobecqms.net/bin/services/getContactInformationJSON?country=malaysia&city=penang
		 * @param {string} country [description]
		 * @param {string} city    [description]
		 */
		function getAddresses(country:string, city:string):any {
			let dfd = $.Deferred();
			let countryUrl:string = _self.$scope.attr('data-get-country-contact-url');

			$.get(countryUrl, {country: country, city: city}).done((data:any) => {
					dfd.resolve(data, status);
			}).fail((error:any) => {
					dfd.reject(error, status);
			});

			// Return the Promise so caller can't change the Deferred
			return dfd.promise();
		}
	}

	/**
	 * [populateAddresses description]
	 * populate received address data into contact info fields
	 * shwo container (fadeIn) on completing data population
	 * @param  {any} data [retrieved address data]
	 * @return {any}      [description]
	 */
	populateAddresses(data:any):void {
		let _self = this;
		let contactInfo = $('.helpcontact__contactinfo');

		let contact:any = {
			phone1: 			contactInfo.find('#numberOne'),
			phone2: 			contactInfo.find('#numberTwo'),
			address: 			contactInfo.find('.method--office .office-address'),
			email: 				contactInfo.find('.method--email .link'),
			facebook: 			contactInfo.find('.method--facebook .link'),
			phone: 				contactInfo.find('.method--phone .link'),
			phoneLabel: 		contactInfo.find('.method--phone'),
			addressLabel: 		contactInfo.find('.method--office'),
			emailLabel: 		contactInfo.find('.method--email'),
			facebookLabel:		contactInfo.find('.method--facebook'),
			emailTitle: 		contactInfo.find('.method--email h3'),
			addressTitle: 		contactInfo.find('.method--office h3'),
			phoneTitle: 		contactInfo.find('.method--phone h3'),
			facebookTitle: 		contactInfo.find('.method--facebook h3'),
			emailUsIcon: 		contactInfo.find('.method--email .method-heading .method-icon i'),
			addressIcon: 		contactInfo.find('.method--office .method-heading .method-icon i'),
			callUsIcon: 		contactInfo.find('.method--phone .method-heading .method-icon i'),
			facebookIcon: 		contactInfo.find('.method--facebook .method-heading .method-icon i')
		};

		contactInfo.fadeOut(500, function(){
			if (data !== undefined) {
				// phone number
				if (data.contactinformation.callHotLineNumber1) {
					contact.phone1.attr({
						href: 'tel:' + data.contactinformation.callHotLineNumber1
					});
					contact.phone1.text(data.contactinformation.callHotLineNumber1);
					contact.phone1.fadeIn();
					contact.phoneLabel.fadeIn();
				} else {
					contact.phoneLabel.fadeOut();
					contact.phone1.fadeOut().empty();
				}

				if (data.contactinformation.callHotLineNumber2) {
					contact.phone2.attr({
						href: 'tel:' + data.contactinformation.callHotLineNumber2
					});
					contact.phone2.text(data.contactinformation.callHotLineNumber2);
					contact.phone2.fadeIn();
					contact.phoneLabel.fadeIn();
				} else {
					contact.phoneLabel.fadeOut();
					contact.phone2.fadeOut().empty();
				}

				// hide all phone fields if values are not present
				if (data.contactinformation.callUsIcon) {
					contact.phoneTitle.text(data.contactinformation.callUsLabel);
					contact.callUsIcon.attr('class', 'fa ' + data.contactinformation.callUsIcon);
					contact.phoneLabel.fadeIn();
				} else {
					contact.phoneLabel.fadeOut();
				}

				// email
				if (data.contactinformation.emailUsIcon) {
					contact.email.attr({
						href: 'mailto:'+data.contactinformation.email
					});
					contact.email.text(data.contactinformation.email);
					contact.emailTitle.text(data.contactinformation.emailSectionLabel);
					contact.emailUsIcon.attr('class', 'fa ' + data.contactinformation.emailUsIcon);
					contact.email.fadeIn();
					contact.emailLabel.fadeIn();
				} else {
					contact.emailLabel.fadeOut();
					contact.email.fadeOut().empty();
				}

				// facebook
				if (data.contactinformation.facebookIcon) {
					contact.facebook.attr({
						href: data.contactinformation.facebookLink
					});
					contact.facebook.find('span').text(data.contactinformation.facebookLabel);
					contact.facebookTitle.text(data.contactinformation.facebookSectionLabel);
					contact.facebookIcon.attr('class', 'fa ' + data.contactinformation.facebookIcon);
					contact.facebook.fadeIn();
					contact.facebookLabel.fadeIn();
				} else {
					contact.facebookLabel.fadeOut();
					contact.facebook.fadeOut().empty();
				}

				// address title
				// if (data.contactinformation.addressTitle) {
				// 	contact.address.find('h4').text(data.contactinformation.addressTitle);
				// 	contact.address.find('h4').fadeIn();
				// } else {
				// 	contact.address.find('h4').fadeOut().empty();
				// }

				// address
				if (data.contactinformation.addressIcon) {
					contact.address.find('h4').text(data.contactinformation.addressTitle);
					contact.address.find('p').text(data.contactinformation.address);
					contact.addressTitle.text(data.contactinformation.addressSectionLabel);
					contact.addressIcon.attr('class', 'fa ' + data.contactinformation.addressIcon);
					contact.address.find('p').fadeIn();
					contact.addressLabel.fadeIn();
				} else {
					contact.addressLabel.fadeOut();
					contact.address.find('p').fadeOut().empty();
				}

				// address link
				if (data.contactinformation.addressIcon) {
					contact.address.find('.link').attr({
						href: data.contactinformation.addressLink
					});
					contact.address.find('.link span').text(data.contactinformation.addressLabel);
					contact.address.find('.link').fadeIn();
				} else {
					contact.address.find('.link').fadeOut().empty();
				}

			}
		}).fadeIn();
	}
}

let scope:Element = document.querySelector('#helpcontact-form');
if (scope){
	try {
		let helpContactSearch = new helpcontactsearch();
		$(document).ready(function(){
			helpContactSearch.getContactCountriesJSON().then((countryData:any) => {
				helpContactSearch.initContactSearch(countryData);
			});
			helpContactSearch.googleMapEmbed();
		});
	} catch(e) {console.error(e);}
}
